// web-config.json 키 경로 → 한글 이름/설명 (원문: 루트 web-config.txt)
// 여기 없는 키는 모달에서 영문 키 그대로 표시됨
export const WEB_CONFIG_LABELS: Record<string, { label: string; desc?: string }> = {
  // ── 자동 학습 ──
  AUTO_TRAIN: { label: "자동 학습", desc: "collect-image 자동 학습 파이프라인 설정" },
  "AUTO_TRAIN.AUTO_CONFIG_VIEWER": { label: "자동 학습 설정 보기" },
  "AUTO_TRAIN.SETTING": { label: "설정값" },
  "AUTO_TRAIN.SETTING.DS_COLLECT_TIME_SEC": {
    label: "데이터 수집 시간(초)",
    desc: "collectImage 호출 시점부터 이 시간 동안 쌓인 이미지로 데이터셋을 자동 생성",
  },
  "AUTO_TRAIN.SETTING.DS_MIN_TRAIN_COUNT_PCT": {
    label: "최소 OK 비율(%)",
    desc: "수집 이미지 중 OK가 이 비율보다 적으면, score가 낮은 NG부터 OK로 재분류해 채움",
  },
  "AUTO_TRAIN.SETTING.DS_RATIO": {
    label: "학습 데이터 비율",
    desc: "OK 이미지 중 train 비율(0~1). 나머지는 valid, NG는 항상 전량 valid",
  },
  "AUTO_TRAIN.SETTING.TR_LIMIT_COUNT": {
    label: "학습 목표 이미지 수",
    desc: "적으면 반복 학습으로 채우고, 많으면 이 개수만큼 무작위 샘플링",
  },
  "AUTO_TRAIN.SETTING.TEST_DATASET_UUID": {
    label: "테스트 데이터셋 UUID",
    desc: "설정 시 새 데이터셋 없이 이 데이터셋으로 바로 학습→저장 (테스트용, 평소엔 비워둘 것)",
  },
  "AUTO_TRAIN.STEP": { label: "단계 진행" },
  "AUTO_TRAIN.STEP.AUTO_START_TRAIN": {
    label: "학습 자동 시작",
    desc: "끄면 데이터셋 생성 후 멈추고 start-training 호출을 기다림",
  },
  "AUTO_TRAIN.STEP.AUTO_SAVE": {
    label: "검사모델 자동 저장",
    desc: "끄면 학습 후 멈추고 save-model 호출을 기다림",
  },
  "AUTO_TRAIN.STEP.RULE_AUTO_CHANGE": {
    label: "검사규칙 모델 자동 교체",
    desc: "자동 저장 성공 시, 원본 모델을 쓰던 가장 최근 검사규칙을 새 모델로 교체",
  },
  "AUTO_TRAIN.STEP.CLEANUP_AUTO_TRAIN": {
    label: "자동 학습 정리",
    desc: "(미구현) 자동 학습이 만든 데이터셋/학습 레코드 정리",
  },

  // ── 기타 기능 ──
  // ── 디펙 ──
  AUGMENTATION: { label: "디펙", desc: "디펙 옵션 UI 노출" },
  "AUGMENTATION.OPTION_VIEW": {
    label: "디펙 옵션 표시",
    desc: "끄면 학습 설정 팝업에서 디펙 옵션 칸과 이미지 미리보기가 사라지고 학습 조건만 남음",
  },

  ETC_CONTROLL: { label: "검사/기타 기능", desc: "검사 및 기타 화면 기능 노출" },
  "ETC_CONTROLL.AI_STRENGTH_CONTROLL": { label: "검출 강도 조절", desc: "검사 검출 강도(민감도) 조절 UI 노출" },
  "ETC_CONTROLL.IMAGE_LENGTH_MEASUREMENT": { label: "이미지 길이 측정", desc: "이미지 길이 측정 기능 노출" },
  "ETC_CONTROLL.IMAGE_DELETE_VIEW_IN_STATUS_PAGE": {
    label: "검사현황 이미지 일괄삭제",
    desc: "검사현황 페이지의 필터 조건 기반 일괄삭제 버튼 노출 (관리자 + 비밀번호 재인증)",
  },
  "ETC_CONTROLL.HISSO_MODE": { label: "HISSO 로그인 모드", desc: "HISSO SSO 로그인 사용" },
  "ETC_CONTROLL.SIM_SETTING_CONFIG_OPTION_VIEW": {
    label: "AVI_SIM config 옵션 노출",
    desc: "AVI_SIM 설정의 config 옵션 노출",
  },
  "ETC_CONTROLL.TRAIN_NAME_AUTO_FILL": {
    label: "학습 이름 자동 채움",
    desc: "새 학습 시 최신 검사규칙 recipe로 학습 이름 자동 입력",
  },
  "ETC_CONTROLL.INSPMODEL_OVERWRITE_SAME_NAME": {
    label: "동명 검사모델 덮어쓰기",
    desc: "켜면 저장 후 같은 이름의 예전 모델 삭제 (기초학습/사용 중인 모델은 보존)",
  },
  "ETC_CONTROLL.VIRTUAL_KEYBOARD": { label: "가상 키보드" },
  "ETC_CONTROLL.PREVENT_DUPLICATE_LOGIN": { label: "중복 로그인 제한", desc: "동일 ID 동시 접속 제한" },
  "ETC_CONTROLL.REQUIRE_DELETE_PASSWORD": { label: "삭제 시 비밀번호 확인" },
  "ETC_CONTROLL.BOUNDARY_SAMPLE_BUTTON": { label: "경계 샘플 버튼" },

  // ── 설정 페이지 ──
  SETTING_PAGE_CONTROLL: { label: "설정 페이지 항목", desc: "설정 페이지 항목 노출" },
  "SETTING_PAGE_CONTROLL.LOGO_URL": { label: "로고 이미지 URL", desc: "비워두면 기본 로고 사용" },
  "SETTING_PAGE_CONTROLL.LANGUAGE_FILE_DELETE_VIEW": {
    label: "언어 파일 삭제 버튼",
    desc: "언어 설정 탭의 언어 파일 삭제 버튼 노출",
  },
  "SETTING_PAGE_CONTROLL.SERVER_OFF_BUTTON_VIEW": { label: "서버 종료 버튼", desc: "서버 종료 버튼 노출" },
  "SETTING_PAGE_CONTROLL.AVI_SIM_DOWNLOAD_VIEW": {
    label: "AVI_SIM 다운로드",
    desc: "AVI_SIM 데스크톱 앱 다운로드 항목 노출",
  },
  "SETTING_PAGE_CONTROLL.DB_MANAGEMENT_VIEW": { label: "DB 관리", desc: "DB 관리(백업/복원 등) 항목 노출" },
  "SETTING_PAGE_CONTROLL.DELETE_ALL_DATA_VIEW": {
    label: "모든 데이터 삭제",
    desc: "기타 설정의 '모든 데이터 삭제' 항목 노출 (관리자 전용, 비밀번호 재인증)",
  },

  // ── 데모 ──
  DEMO_SETTING: { label: "데모/파일 탐색" },
  "DEMO_SETTING.CURRENT_FOLDER": {
    label: "기본 폴더 경로",
    desc: '데모용 파일 탐색 기본 폴더 (기본: "/data1/datasets")',
  },

  // ── 간소화 워크플로우 ──
  SIMPLE_STEP: { label: "간소화 워크플로우", desc: "간소화 워크플로우 자동 채움" },
  "SIMPLE_STEP.AUTO_FILL_INSP_STATUS": {
    label: "검사현황 필터 자동 적용",
    desc: "검사현황 진입 시 최신 데이터 material_name 필터 자동 적용",
  },
  "SIMPLE_STEP.AUTO_FILL_TRAIN_NAME": {
    label: "학습 이름 자동 채움",
    desc: "데이터셋 생성 후 학습 폼 이동 시 학습 이름 자동 입력",
  },
  "SIMPLE_STEP.AUTO_CHANGE_RULE": { label: "검사규칙 자동 변경" },
  "SIMPLE_STEP.AUTO_FILL_FILTER_OPTION": { label: "필터 옵션 자동 채움" },
  "SIMPLE_STEP.AUTO_START_VALID": { label: "검증 자동 시작" },
  "SIMPLE_STEP.AUTO_FILL_OK_LABEL": { label: "OK 라벨 자동 채움" },
  "SIMPLE_STEP.MAKE_DATASET_NG_CONDITION": { label: "데이터셋 NG 조건" },
  "SIMPLE_STEP.AUTO_UPDATE_THRESHOLD": { label: "임계값 자동 갱신" },
  "SIMPLE_STEP.AUTO_UPDATE_THRESHOLD.USE": { label: "사용" },
  "SIMPLE_STEP.AUTO_UPDATE_THRESHOLD.TARGET": { label: "목표" },
  "SIMPLE_STEP.AUTO_UPDATE_THRESHOLD.TARGET.AUTO": { label: "자동" },
  "SIMPLE_STEP.AUTO_UPDATE_THRESHOLD.TARGET.TARGET_FPR": { label: "목표 FPR" },
  "SIMPLE_STEP.AUTO_UPDATE_THRESHOLD.TARGET.MARGIN": { label: "여유값(margin)" },

  // ── 검사현황 팝업 ──
  INSP_MODAL_SETTING: {
    label: "검사현황 상세 팝업 크기",
    desc: "SITE_OPTION별 크기, 없으면 DEFAULT 사용. width/height 중 하나라도 0이면 전체화면",
  },
  "INSP_MODAL_SETTING.DEFAULT": { label: "기본(DEFAULT)" },
  "INSP_MODAL_SETTING.DEFAULT.width": { label: "너비(px)" },
  "INSP_MODAL_SETTING.DEFAULT.height": { label: "높이(px)" },
  "INSP_MODAL_SETTING.SSG.width": { label: "너비(px)" },
  "INSP_MODAL_SETTING.SSG.height": { label: "높이(px)" },

  // ── 멀티 라벨 / 어노테이션 ──
  MULTI: { label: "멀티 라벨" },
  "MULTI.IS_MULTI": { label: "멀티 라벨 사용" },
  "MULTI.LABELS": { label: "라벨 목록" },
  ANNOTATION: { label: "어노테이션" },
  "ANNOTATION.USE": { label: "어노테이션 사용" },
};
